/**
 * Limites de data para validação em formulários.
 * Datas de contratos (fechamento, contratação, parcelas, etc.): a partir de 01/01/2000
 * Datas de nascimento: a partir de 01/01/1900
 */
export const MIN_CONTRACT_DATE = "2000-01-01";
export const MIN_BIRTH_DATE = "1900-01-01";

/** Retorna a data de hoje no formato YYYY-MM-DD (limite máximo para campos de data). */
export const getMaxTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
